<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-lookup"></require>
  <require from="controls/as-widget-stack"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="components/deviation-team-region-director-panel"></require>

  <div style="border-bottom: 1px solid #e9ecef">
    <as-form-section heading.bind="model.name">
      <div slot="body">
        <div class="form-row">
          <div class="col-sm-6">
            <bs-form-input label="Name" placeholder="Deviation team name" value.bind="model.name & validate" maxlength="500"></bs-form-input>
          </div>
          <div class="col-sm-6">
            <bs-form-input label="Team Type" placeholder="Deviation team name" value.bind="model.teamType.name" disabled.bind="true"></bs-form-input>
          </div>
        </div>
        <div class="form-row">
          <div if.bind="model.teamStrategy.hasTeamLeader" class="col-sm-6">
            <bs-form-lookup label.bind="teamLeaderGroupLabel" placeholder="Find by name, login or email" item.bind="model.teamLeader & validate" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" tooltip="Type to search for bp employee, then pick the one from the list" maxlength="100"></bs-form-lookup>
          </div>
          <div if.bind="model.teamStrategy.hasEmailAddress" class="col-sm-6">
            <bs-form-input label="Email Address" placeholder="Email address" value.bind="model.emailAddress & validate" maxlength="100"></bs-form-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div class="sc-buttons-container text-nowrap" style="text-align: right; margin-left: auto;">
              <button type="submit" class="btn btn-primary" af-mutex-click.call="submit()" if.bind="submitButtonVisible">
                <i class="fas fa-paper-plane"></i> ${model.id ? 'Save Changes' : 'Submit New'}
              </button>
              <button type="button" class="btn btn-light" af-mutex-click.call="cancel()" if.bind="cancelButtonVisible">
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div if.bind="model.teamStrategy.hasMembers" class="form-row">
          <div class="col">
            <h5>Team Members</h5>
            <as-widget-stack kind="admin-user-selector" new-item-widget-visible.bind="isMemberEditing" add-new-item.call="addNewMember(item)" remove-item.call="removeMember(item)" items.bind="deviationTeamDetailModel.membersWrapper" empty-item-template.bind="newEmptySystemUserWrapper"></as-widget-stack>
          </div>
        </div>
        <div if.bind="model.teamStrategy.hasDirectors" class="form-row">
          <div class="col">
            <h5>Region Directors</h5>
            <div class="sc-buttons-container">
              <button type="button" class="btn btn-icon text-primary" af-mutex-click.call="createNewRegionDirector()">
                <i class="fas fa-plus"></i>
              </button>
            </div>
            <div class="as-widget-list">
              <div class="as-widget-list__item li-deviation-team-region-director-panel" repeat.for="item of regionDirectors">
                <div class="as-widget-list__item-main">
                  <deviation-team-region-director-panel control-model.bind="item" changed.bind="item.hasChanged"></deviation-team-region-director-panel>
                </div>
                <div class="as-widget-list__item-controls">
                  <div class="fa-lg fa-fw"></div>
                  <div class="btn-group-vertical btn-group-sm">
                    <button type="button" class="btn btn-icon text-danger" title="Archive" af-mutex-click.call="archiveRegionDirector(item)" show.bind="!item.hasChanged && item.data.isActive && item.data.id" bs-tooltip>
                      <i class="fas fa-trash"></i>
                    </button>
                    <button type="button" class="btn btn-icon text-success" title="Restore" af-mutex-click.call="restoreRegionDirector(item)" show.bind="!item.hasChanged && !item.data.isActive && item.data.id" bs-tooltip>
                      <i class="fas fa-trash-restore"></i>
                    </button>
                    <button type="button" class="btn btn-icon text-primary" title="Submit" af-mutex-click.call="saveRegionDirector(item)" show.bind="item.hasChanged && item.data.isActive" bs-tooltip>
                      <i class="fas fa-check"></i>
                    </button>
                    <button type="button" class="btn btn-icon text-danger" title="Cancel" af-mutex-click.call="cancelRegionDirectorChanges(item)" show.bind="(item.hasChanged && item.data.isActive) || !item.data.id" bs-tooltip>
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </as-form-section>
  </div>
</template>
